<template lang="pug">
  mixer-loads-list(v-if="!isMobile")
  mixer-loads-list-mobile(v-else)
</template>

<script>
import adaptationMixin from '@/mixins/adaptation.mixin.js'

const MixerLoadsList = () => import('./MixerLoadsList')
const MixerLoadsListMobile = () => import('./MixerLoadsListMobile')

export default {
  name: 'MixerLoads',

  mixins: [adaptationMixin],

  components: {
    MixerLoadsList,
    MixerLoadsListMobile,
  }
}
</script>
